import { createAction, props } from '@ngrx/store';
import { Tariff } from 'brain-data/model/tariff.model';

export const loadTariffs = createAction('[Tariffs] load');
export const loadTariffsSuccess = createAction(
  '[Tariffs] load success',
  props<{ tariffs: Tariff[] }>(),
);
export const loadTariffsError = createAction(
  '[Tariffs] load error',
  props<{ error: Error }>(),
);
